import * as backendConstants from 'lib/generated_constants/participant_attributes';

export const updateSections = {
  INFO: 'participant-info',
  PASSWORD: 'participant-password',
};

const BROWSERS_FORM_INPUT_LABEL = 'Browsers';
const COMPUTER_OS_FORM_INPUT_LABEL = 'Computer operating systems';
const COMPUTER_WEBCAM_FORM_INPUT_LABEL =
  'Do you have a computer with a webcam?';
const DISABILITIES_FORM_INPUT_LABEL =
  'Do you identify as having any of the following disabilities?';
const HOUSEHOLD_INCOME_FORM_INPUT_LABEL = 'Household income per year';
const LEVEL_OF_EDUCATION_FORM_INPUT_LABEL = 'Highest level of education';
const SMALL_BUSINESS_OWNER_FORM_INPUT_LABEL = 'Small business owner?';
const SMARTPHONE_OS_FORM_INPUT_LABEL = 'Smartphone operating systems';
const TABLET_OS_FORM_INPUT_LABEL = 'Tablet operating systems';

export const attributeSlugsToInputLabels = {
  [backendConstants.BROWSERS_SLUG]: BROWSERS_FORM_INPUT_LABEL,
  [backendConstants.COMPUTER_OS_SLUG]: COMPUTER_OS_FORM_INPUT_LABEL,
  [backendConstants.COMPUTER_WEBCAM_SLUG]: COMPUTER_WEBCAM_FORM_INPUT_LABEL,
  [backendConstants.DISABILITIES_SLUG]: DISABILITIES_FORM_INPUT_LABEL,
  [backendConstants.HOUSEHOLD_INCOME_SLUG]: HOUSEHOLD_INCOME_FORM_INPUT_LABEL,
  [backendConstants.HOUSEHOLD_INCOME_AUD_SLUG]:
    HOUSEHOLD_INCOME_FORM_INPUT_LABEL,
  [backendConstants.HOUSEHOLD_INCOME_CAD_SLUG]:
    HOUSEHOLD_INCOME_FORM_INPUT_LABEL,
  [backendConstants.HOUSEHOLD_INCOME_EUR_SLUG]:
    HOUSEHOLD_INCOME_FORM_INPUT_LABEL,
  [backendConstants.HOUSEHOLD_INCOME_GBP_SLUG]:
    HOUSEHOLD_INCOME_FORM_INPUT_LABEL,
  [backendConstants.HOUSEHOLD_INCOME_INR_SLUG]:
    HOUSEHOLD_INCOME_FORM_INPUT_LABEL,
  [backendConstants.HOUSEHOLD_INCOME_MXN_SLUG]:
    HOUSEHOLD_INCOME_FORM_INPUT_LABEL,
  [backendConstants.HOUSEHOLD_INCOME_NZD_SLUG]:
    HOUSEHOLD_INCOME_FORM_INPUT_LABEL,
  [backendConstants.HOUSEHOLD_INCOME_SGD_SLUG]:
    HOUSEHOLD_INCOME_FORM_INPUT_LABEL,
  [backendConstants.HOUSEHOLD_INCOME_USD_SLUG]:
    HOUSEHOLD_INCOME_FORM_INPUT_LABEL,
  [backendConstants.LEVEL_OF_EDUCATION_SLUG]:
    LEVEL_OF_EDUCATION_FORM_INPUT_LABEL,
  [backendConstants.SMALL_BUSINESS_OWNER_SLUG]:
    SMALL_BUSINESS_OWNER_FORM_INPUT_LABEL,
  [backendConstants.SMARTPHONE_OS_SLUG]: SMARTPHONE_OS_FORM_INPUT_LABEL,
  [backendConstants.TABLET_OS_SLUG]: TABLET_OS_FORM_INPUT_LABEL,
};

export const attributeSlugsToDefaultOptionNames = {
  [backendConstants.CHILDREN_SLUG]:
    backendConstants.CHILDREN_DEFAULT_OPTION_NAME,
  [backendConstants.COMPUTER_OS_SLUG]:
    backendConstants.COMPUTER_OS_DEFAULT_OPTION_NAME,
  [backendConstants.SMARTPHONE_OS_SLUG]:
    backendConstants.SMARTPHONE_OS_DEFAULT_OPTION_NAME,
  [backendConstants.TABLET_OS_SLUG]:
    backendConstants.TABLET_OS_DEFAULT_OPTION_NAME,
  [backendConstants.TYPE_OF_INCOME_SLUG]:
    backendConstants.TYPE_OF_INCOME_DEFAULT_OPTION_NAME,
};

export * from 'lib/generated_constants/participant_attributes';
